export default __webpack_public_path__ + "static/poster-healthcare-503ff8de1b2aafa0b7ffbf6af3453f37.jpg";